import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { GREY_A, GREY_E } from '../../constants/Colors';
import FormattedBlockText from '../../utils/FormattedBlockText';
import bindMethods from '../../utils/bindMethods';

const jssStyles = {
  wrap: (props) => ({
    width: '100%',
    display: 'flex',
    flexDirection: props?.textareaData?.noWrap ? 'column' : 'row',
    gap: '10px',
  }),
  textarea: {
    width: '100%',
    padding: '10px',
    boxSizing: 'border-box',
  },
  preview: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '10px 20px',
    backgroundColor: '#fff',
    border: '1px solid',
    borderColor: GREY_E,
    borderRadius: '3px',
  },
  instructions: {
    marginTop: '10px',
  },
  tag: {
    display: 'inline-block',
    padding: '4px 6px',
    margin: '0 5px 5px 0',
    borderColor: GREY_E,
    borderRadius: '3px',
    border: '1px solid',
    color: GREY_A,
    fontSize: '11px',
    lineHeight: 1,
  },
};

class TextareaForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formText: this.props.initialTextData ?? '',
    };
    this.bound = bindMethods(this, ['onChangeText']);
  }

  onChangeText(e) {
    this.setState({
      formText: e.target.value,
    });
  }

  render() {
    const {
      classes,
      textareaData: {
        name,
        cols,
        rows,
        required,
        placeholder,
      } = {},
    } = this.props;
    return (
      <div>
        <div className={classes.wrap}>
          <textarea
            value={this.state.formText}
            name={name}
            cols={cols}
            rows={rows}
            required={required}
            onChange={this.bound.onChangeText}
            className={classes.textarea}
            data-testid="text-area"
            placeholder={placeholder ?? ''}
          />
          <div className={classes.preview}>
            <FormattedBlockText
              text={this.state.formText}
              showError
            />
          </div>
        </div>
        <div className={classes.instructions}>
          <span className={classes.tag}>*bold*</span>
          <span className={classes.tag}>_italic_</span>
          <span className={classes.tag}>~~del~~</span>
          <span className={classes.tag}>* list</span>
          <span className={classes.tag}>1. no list</span>
          <span className={classes.tag}>http://url/ becomes &lt;a href=&quot;http://url/&quot;&gt;http://url/&lt;/a&gt;</span>
          <span className={classes.tag}>custom link: [label](http://url/) to open in new tab</span>
          <span className={classes.tag}>img tag: ![](http://url/)</span>
        </div>
      </div>
    );
  }
}

TextareaForm.propTypes = {
  initialTextData: PropTypes.string,
  textareaData: PropTypes.shape({
    name: PropTypes.string,
    cols: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    required: PropTypes.string,
    noWrap: PropTypes.bool,
    placeholder: PropTypes.string,
  }),
  classes: PropTypes.object.isRequired,
};

export default injectSheet(jssStyles)(TextareaForm);
